webpackJsonp([222457311475995],{

/***/ 231:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var contacts = [{
	  title: 'Prodaja',
	  contacts: [{
	    name: 'Džanan Drobić, dipl. ing.',
	    phone: '+385 (0) 1 2498-982',
	    fax: '+385 (0) 1 2406-237',
	    email: 'dzanan.drobic@iskraemeco.hr'
	  }]
	}, {
	  title: 'Računovodstvo',
	  contacts: [{
	    name: 'Katica Mustapić, dipl. oec.',
	    phone: '+385 (0) 1 2498-986',
	    fax: '+385 (0) 1 2498-981',
	    email: 'financije@iskraemeco.hr'
	  }, {
	    name: 'Višnja Kršić',
	    phone: '+385 (0) 1 2498-985',
	    email: 'visnja.krsic@iskraemeco.hr'
	  }]
	}, {
	  title: 'Podrška brojila',
	  contacts: [{
	    name: 'Ante Bračić',
	    phone: '+385 (0) 1 2498-991',
	    email: 'ante.bracic@iskraemeco.hr'
	  }]
	}, {
	  title: 'Automatizacija',
	  contacts: [{
	    name: 'Marijan Metikoš, dipl. ing.',
	    phone: '+385 (0) 1 2498-992',
	    email: 'marijan.metikos@iskraemeco.hr'
	  }]
	}, {
	  title: 'Proizvodnja i laboratorij',
	  contacts: [{
	    name: 'Zvonimir Harapin, ing. el.',
	    phone: '+385 (0) 1 2498-999',
	    email: 'zvonimir.harapin@iskraemeco.hr'
	  }]
	}];
	
	exports.default = contacts;
	module.exports = exports['default'];

/***/ }),

/***/ 331:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(35);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _components = __webpack_require__(22);
	
	var _contacts = __webpack_require__(231);
	
	var _contacts2 = _interopRequireDefault(_contacts);
	
	__webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KontaktPage = function KontaktPage() {
	  return _react2.default.createElement(
	    _gatsbyPluginPageTransitions2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'kontakt-main-wrapper' },
	        _react2.default.createElement(_components.MainContact, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'kontakt-list-wrapper' },
	        _react2.default.createElement(_components.Contacts, { contacts: _contacts2.default })
	      )
	    )
	  );
	};
	
	exports.default = KontaktPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-kontakt-js-f1860f1e5d9f60df7152.js